module.exports = __webpack_public_path__ + "right.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/right.svg?color1=%23333333&color2=
// module id = 545
// module chunks = 67